import React from 'react';
import { DoorOpen, Waves, Trophy, Car, Dog, Home, Users, Footprints, Baby, Dumbbell, TreePine, Shield } from 'lucide-react';
import { amenities } from '../data/mock';

const iconMap = { DoorOpen, Waves, Trophy, Car, Dog, Home, Users, Footprints, Baby, Dumbbell, TreePine, Shield };

const AmenitiesSection = () => {
  return (
    <section id="amenities" className="py-16 sm:py-24 bg-gradient-to-b from-[#0a1628] to-[#0d1f35]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-16">
          <span className="text-[#c9a961] text-xs sm:text-sm font-semibold tracking-widest uppercase">Lifestyle</span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mt-2 sm:mt-3 mb-4 sm:mb-6">World-Class Amenities</h2>
          <div className="w-20 sm:w-24 h-1 bg-gradient-to-r from-transparent via-[#c9a961] to-transparent mx-auto mb-4 sm:mb-6" />
          <p className="text-white/60 text-sm sm:text-base max-w-2xl mx-auto px-4">Experience unparalleled luxury</p>
        </div>

        {/* Amenities Grid */}
        <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 gap-3 sm:gap-6">
          {amenities.map((amenity, index) => {
            const IconComponent = iconMap[amenity.icon];
            return (
              <div key={index} className="group bg-white/5 border border-white/10 rounded-xl sm:rounded-2xl p-3 sm:p-6 text-center hover:bg-white/10 hover:border-[#c9a961]/30 transition-all duration-500">
                <div className="w-10 h-10 sm:w-16 sm:h-16 mx-auto mb-2 sm:mb-4 bg-gradient-to-br from-[#c9a961]/20 to-[#c9a961]/5 rounded-xl sm:rounded-2xl flex items-center justify-center">
                  {IconComponent && <IconComponent className="w-5 h-5 sm:w-8 sm:h-8 text-[#c9a961]" />}
                </div>
                <p className="text-white/80 font-medium text-xs sm:text-sm">{amenity.name}</p>
              </div>
            );
          })}
        </div>

        {/* Feature Image */}
        <div className="mt-10 sm:mt-16 relative rounded-2xl sm:rounded-3xl overflow-hidden">
          <img src="https://embassyverde.com/images/Mask-Group-12.png" alt="Embassy Springs Township" className="w-full h-[200px] sm:h-[400px] object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0a1628]/90 via-[#0a1628]/50 to-transparent" />
          <div className="absolute bottom-0 left-0 p-4 sm:p-12">
            <h3 className="text-xl sm:text-4xl font-bold text-white mb-2 sm:mb-4">Resort-Style Living</h3>
            <p className="text-white/70 max-w-md text-sm sm:text-lg">Every amenity designed to elevate your experience</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AmenitiesSection;
